module.exports = __webpack_public_path__ + "static/img/huaweiMateBookD.1173f1c5.png";